import { getFullName } from '../../../utils';
import { styledDefaultColDef } from '../../../extras/cellRenderers';

const getRolesName = (roles) => {
  return roles.map((role) => role.name).join(', ');
};

export const userColumnDefs = [
  { field: 'id', hide: true },
  {
    headerName: 'Users',
    field: 'firstName',
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      valueGetter: (props) => getFullName(props.data?.user),
      debounceMs: 200,
    },
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const nameA = getFullName(nodeA.data?.user);
      const nameB = getFullName(nodeB.data?.user);
      const comparison = nameA.localeCompare(nameB);
      return comparison;
    },
    valueGetter: (params) => getFullName(params.data?.user),
  },
  {
    headerName: 'Roles Assigned',
    field: 'roles',
    valueGetter: (params) => getRolesName(params.data?.roles),
    filterParams: {
      valueGetter: (params) => getRolesName(params.data?.roles),
    },
  },
  {
    headerName: 'Actions',
    field: 'actions',
    cellRenderer: 'btnCellRenderer',
    pinned: 'right',
    sortable: false,
    suppressMenu: true,
  },
];

export const rolesColumnDefs = [
  { field: 'id', hide: true },
  {
    headerName: 'Role Name',
    field: 'name',
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      debounceMs: 200,
    },
  },
  {
    headerName: 'Modules Assigned',
    field: 'modules',
    valueGetter: (params) => {
      return params.data?.modules?.join(', ') || '	-- No Modules --';
    },
  },
  {
    headerName: 'Actions',
    field: 'actions',
    cellRenderer: 'btnCellRenderer',
    pinned: 'right',
    sortable: false,
    suppressMenu: true,
  },
];

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: true,
};
